import { render } from "./ProfileView.vue?vue&type=template&id=59bd7537&scoped=true"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"

import "./ProfileView.vue?vue&type=style&index=0&id=59bd7537&lang=scss"
import "./ProfileView.vue?vue&type=style&index=1&id=59bd7537&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bd7537"]])

export default __exports__